// CustomTabs.jsx
import React from 'react';
import './custom-tabs.scss';

const CustomTabs = ({ tabs, activeIndex, setActiveIndex }) => {
  return (
    <div className="custom-tabs" dir="rtl">
      <div className="tabs-header">
        {tabs.map((tab, index) => (
          <button
            key={index}
            className={`tab-button ${index === activeIndex ? 'active' : ''}`}
            onClick={() => setActiveIndex(index)}
          >
            {tab.label}
          </button>
        ))}
      </div>
      <div className="tabs-body">
        {tabs[activeIndex]?.content}
      </div>
    </div>
  );
};

export default CustomTabs;
